const env = import.meta.env;

function asBoolean(value: string | undefined): boolean {
  return value?.toString().toLowerCase() === "true";
}

function stripTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, "");
}

export function resolvePublicApiBaseUrl(apiBaseUrl: string, explicitPublicApiBaseUrl?: string): string {
  const explicitBase = stripTrailingSlashes(explicitPublicApiBaseUrl || "");
  if (explicitBase) {
    return explicitBase;
  }

  const base = stripTrailingSlashes(apiBaseUrl);
  if (!base || !base.includes("traderly-apim.azure-api.net") || base.endsWith("/open")) {
    return base;
  }

  return `${base}/open`;
}

export const config = {
  apiBaseUrl: env.VITE_API_BASE_URL || "",
  publicApiBaseUrl: resolvePublicApiBaseUrl(env.VITE_API_BASE_URL || "", env.VITE_PUBLIC_API_BASE_URL),
  bookingPageBaseUrl: stripTrailingSlashes(env.VITE_BOOKING_PAGE_BASE_URL || "https://booking.setin.ai"),
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY || "",
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || "",
    projectId: env.VITE_FIREBASE_PROJECT_ID || "",
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: env.VITE_FIREBASE_APP_ID || "",
  },
  google: {
    clientId: env.VITE_GOOGLE_CLIENT_ID || "",
    redirectUri: env.VITE_GOOGLE_REDIRECT_URI || "",
  },
  microsoft: {
    clientId: env.VITE_MICROSOFT_CLIENT_ID || "",
    redirectUri: env.VITE_MICROSOFT_REDIRECT_URI || "",
  },
  gtmId: env.VITE_GTM_ID || "",
  analyticsDebug: asBoolean(env.VITE_ANALYTICS_DEBUG),
  recaptchaSiteKey: env.VITE_RECAPTCHA_SITE_KEY,
  featureFlags: {
    enableMicrosoftAuth: asBoolean(env.VITE_ENABLE_MICROSOFT_AUTH),
    enableFacebookAuth: asBoolean(env.VITE_ENABLE_FACEBOOK_AUTH),
    enableShopify: asBoolean(env.VITE_ENABLE_SHOPIFY),
    enableCliniko: asBoolean(env.VITE_ENABLE_CLINIKO),
    requireRegistrationToken: asBoolean(env.VITE_REQUIRE_REGISTRATION_TOKEN),
  },
} as const;
